/* KV design system: shared behaviours. Each section may also ship its own inline script. */
(function () {
  if (window.KV) return;
  const KV = (window.KV = {});
  KV.money = function (cents, format) {
    format = format || (window.KV_MONEY_FORMAT || '${{amount}}');
    const n = (Number(cents) || 0) / 100;
    const two = n.toFixed(2), comma = two.replace('.', ',');
    return format
      .replace(/\{\{\s*amount_no_decimals\s*\}\}/, Math.round(n).toLocaleString('en'))
      .replace(/\{\{\s*amount_with_comma_separator\s*\}\}/, comma)
      .replace(/\{\{\s*amount_no_decimals_with_comma_separator\s*\}\}/, Math.round(n).toLocaleString('de'))
      .replace(/\{\{\s*amount\s*\}\}/, Number(two).toLocaleString('en', { minimumFractionDigits: 2 }));
  };
  KV.onReady = function (fn) { document.readyState !== 'loading' ? fn() : document.addEventListener('DOMContentLoaded', fn); };
  KV.whenSwiper = function (fn) { if (window.Swiper) return fn(); const t = setInterval(() => { if (window.Swiper) { clearInterval(t); fn(); } }, 50); };
  // Re-init hooks for the theme editor
  document.addEventListener('shopify:section:load', (e) => document.dispatchEvent(new CustomEvent('kv:section:load', { detail: e.detail, bubbles: true })));
})();
